package ru.education.building

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.safeContentPadding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import moe.tlaster.precompose.PreComposeApp
import moe.tlaster.precompose.navigation.NavOptions
import moe.tlaster.precompose.navigation.rememberNavigator
import org.koin.compose.KoinApplication
import ru.education.building.navigation.routes.AppNavigation
import ru.education.building.navigation.widgets.BottomBarWithDot
import ru.education.building.schedule.view.httpclient.appModule
import ru.education.building.theme.CustomAppTheme
import ru.education.building.theme.themeModule


@Composable
fun App() {
    KoinApplication(
        application = { modules(appModule, themeModule) }
    ) {
        CustomAppTheme {
            PreComposeApp {
                val appNavigator = rememberNavigator()
                val currentRoute by appNavigator.currentEntry.collectAsState(null)

                Scaffold(
                    modifier = Modifier
                        .background(MaterialTheme.colorScheme.background)
                        .safeContentPadding()
                        .fillMaxSize(),
                    bottomBar = {
                        BottomBarWithDot(
                            currentRoute = currentRoute?.route?.route,
                            onNavigate = { appNavigator.navigate(it, NavOptions(launchSingleTop = true)) }
                        )
                    }
                ) {
                    paddingValues -> AppNavigation(navigator = appNavigator, paddingValues = paddingValues)
                }
            }
        }
    }
}



